import { IAngularEvent, IRootScopeService, IScope } from "angular";
import { StateService } from "@uirouter/angularjs";
import { AutomationTriggerType, IAutomation } from "../models/automation";

interface IAutomationSidebarRootScopeService extends IRootScopeService {
  newAutomation: IAutomation<AutomationTriggerType>;
}

interface IAutomationSidebarScope extends IScope {
  automationStateName: string;
  currentAutomation: IAutomation<AutomationTriggerType>;
  openAutomationHistory(): void;
  openAutomationEditor(): void;
}
export class AutomationSidebarCtrl {
  public static $inject = ["$state", "$scope", "$rootScope"];

  constructor(private $state: StateService, private $scope: IAutomationSidebarScope, private $rootScope: IAutomationSidebarRootScopeService) {
    const removeAutomationStateChangeListener = this.$rootScope.$on("$automationStateChange", this.onAutomationStateChange);
    const removeCurrentAutomationListener = this.$rootScope.$on("currentAutomation", this.setCurrentAutomation);

    this.$scope.openAutomationHistory = this.openAutomationHistory;
    this.$scope.openAutomationEditor = this.openAutomationEditor;

    this.$scope.$on("$destroy", () => {
      removeAutomationStateChangeListener();
      removeCurrentAutomationListener();
    });

    // dont delete this - for now it is needed for rules ctrl
    this.$rootScope.newAutomation = {} as IAutomation<AutomationTriggerType>;
  }

  private automationStates: {
    rules: string;
    history: string;
    editor: string;
  } = {
    rules: "gtmhub.automation.rules",
    history: "gtmhub.automation.history",
    editor: "gtmhub.automation.rules._all",
  };

  private setCurrentAutomation = (e: IAngularEvent, automation: IAutomation<AutomationTriggerType>): void => {
    this.$scope.currentAutomation = automation;
  };

  private openAutomationHistory = (): void => {
    this.$state.go(this.automationStates.history, { automationId: this.$scope.currentAutomation.id });
  };

  private openAutomationEditor = (): void => {
    this.$state.go(this.automationStates.rules, { automationId: this.$scope.currentAutomation.id });
  };

  private onAutomationStateChange = (): void => {
    this.$scope.automationStateName = this.$state.current.name;
  };
}
